var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumberger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.8C21.0987 22.8 22.8 21.0987 22.8 19C22.8 16.9013 21.0987 15.2 19 15.2C16.9013 15.2 15.2 16.9013 15.2 19C15.2 21.0987 16.9013 22.8 19 22.8Z",
    fill: "#2D142C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86653 22.8C10.9652 22.8 12.6665 21.0987 12.6665 19C12.6665 16.9013 10.9652 15.2 8.86653 15.2C6.76785 15.2 5.06653 16.9013 5.06653 19C5.06653 21.0987 6.76785 22.8 8.86653 22.8Z",
    fill: "#2D142C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1334 22.8C31.2321 22.8 32.9334 21.0987 32.9334 19C32.9334 16.9013 31.2321 15.2 29.1334 15.2C27.0348 15.2 25.3334 16.9013 25.3334 19C25.3334 21.0987 27.0348 22.8 29.1334 22.8Z",
    fill: "#2D142C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumberger);
export default __webpack_public_path__ + "static/media/Humberger.b36f1ab8bda22e6b934e779be7dd1686.svg";
export { ForwardRef as ReactComponent };